var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1178 29.4131C14.4492 29.4183 11.8141 28.8234 9.41053 27.6729L1 29.4486L3.32632 22.5235C-0.83242 16.4204 0.774526 8.54526 7.08421 4.10249C13.3939 -0.3385 22.4558 0.0255151 28.2805 4.95482C31.8452 7.97348 33.5237 12.1286 33.1962 16.2127M24.2632 27.6729H35M29.6316 22.3459V33",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMessage);
export default __webpack_public_path__ + "static/media/NewMessage.84ece4b336538176accfccb6d9f3d74d.svg";
export { ForwardRef as ReactComponent };